import { z } from 'zod';
import { AccountIdSchema } from './accounts';
import { NumericalIdSchema } from './commonTypes';
/**
 * I am putting all encountered User types here.  As we migrate to TS I want to be able to
 * condense them into a unified User type, but for now I'm keeping them separate.
 */
export var UserIdSchema = NumericalIdSchema;
export var UserEmailSchema = z.string().email();
export var UserRoleSchema = NumericalIdSchema;
// Current User from window.current_user
export var WindowCurrentUserSchema = z.object({
    account_id: z.string(),
    id: UserIdSchema
});
// Base User Schema/Type
export var UserSchema = z.object({
    id: UserIdSchema,
    account_id: AccountIdSchema,
    email: UserEmailSchema,
    deactivated: z.boolean(),
    role_id: UserRoleSchema,
    upload_id: NumericalIdSchema.nullable(),
    // Temporary schema addition to cover image uploads
    upload_url: z.string().nullable().optional(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    user_name: z.string(),
    email_confirmed: z.boolean(),
    add_time: z.string(),
    update_time: z.string()
});
// User when returned from company store
export var CompanyStoreUserSchema = UserSchema.extend({
    isCurrentUser: z.boolean(),
    products: z.array(z.object({
        id: z.number()
    }).passthrough())
});
export var CompanyStoreCurrentUserSchema = z.object({
    id: UserIdSchema,
    account_id: AccountIdSchema,
    role_id: UserRoleSchema
});
export var AnalyticsUserSchema = z.object({
    id: UserIdSchema,
    user_name: z.string(),
    email: UserEmailSchema,
    upload_url: z.string().optional(),
    role_id: z.string()
});
